(function () {
  'use strict';

  /* @ngdoc object
   * @name home.licenseSearch
   * @description
   *
   */
  angular
    .module('neo.home.licenseSearch', [
      'ui.router'
    ]);
}());
